<template>
  <!-- START : Phone section per group -->
  <WCFormGroup :field="$v.phone">
    <!-- For each phone on boarding profile -->
    <WCLabel :for="'phone' + phones.did">{{ phones.name }}</WCLabel>
    <WCInput
      autocomplete="tel"
      class="form-control phone-input bg-light"
      :id="'phone' + phones.did"
      :value="phones.phone.value"
      @input="change()"
    />
    <WCValidationErrors />
  </WCFormGroup>
  <!-- END : Phone section per group -->
</template>
<script>
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import { required, helpers } from 'vuelidate/lib/validators';
import { phone } from '@/utils/validators/validators';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import PhoneNumberFormatMixin from '@/mixins/PhoneNumberFormatMixin';
import { ACCOUNT_SETTINGS_OPTIONS } from '@/constants/AppConstants';

export default {
  name: 'WCAccountSettingsPhoneInput',
  components: { WCFormGroup, WCInput, WCValidationErrors, WCLabel },
  mixins: [PhoneNumberFormatMixin],
  emits: ['input', 'update:valid'],

  props: {
    phones: {
      type: Object,
    },
    did: {
      type: String,
    },
  },
  data() {
    return {
      phone: this.phones && this.phones.phone.value,
    };
  },
  mounted() {
    this.$emit('update:valid', !this.$v.$invalid, this.did);
  },
  validations() {
    /**
     * Validator for optional phone field
     */
    const optionalPhone = value =>
      !helpers.req(value) ||
      // eslint-disable-next-line func-names
      (function() {
        return phone(value);
      })();

    return {
      phone:
        this.phones && this.phones.phone.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
          ? { phone, required }
          : { optionalPhone },
    };
  },
  methods: {
    /**
     * Method to change the phone object on input update
     */
    change() {
      const phoneObject = { ...this.phones, phone: { value: this.phone } };
      this.$emit('input', phoneObject);
      this.$emit('update:valid', !this.$v.$invalid, this.did);
      this.changePhoneNumberFormat(phoneObject.phone.value);
    },
    /**
     * Method to format the phone number
     * Uses PhoneNumberFormatMixin
     */
    changePhoneNumberFormat(phoneNumber) {
      this.phone = this.formatPhoneNumber(phoneNumber);
    },
  },
};
</script>
